import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=0c61dcb2&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.scss?vue&type=style&index=0&id=0c61dcb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61dcb2",
  null
  
)

export default component.exports